import NodeJsIcon from "./tech-icons/nodejs-icon.png";
import TsIcon from "./tech-icons/typescript-icon.jpg";
import ReactIcon from "./tech-icons/react-icon.png";
import PostgresIcon from "./tech-icons/postgres-icon.png";
import S3Icon from "./tech-icons/amazon-s3-icon.png";
import GQLIcon from "./tech-icons/gql-icon.png";
import ReduxIcon from "./tech-icons/redux-icon.png";
import HerokuIcon from "./tech-icons/heroku-icon.png";
import KafkaIcon from "./tech-icons/kafka-icon.jpg";
import NextJSIcon from "./tech-icons/nextjs-icon.png";
import ApolloIcon from "./tech-icons/apollo-icon.png";
import StyledComponentIcon from "./tech-icons/styled-components-icon.png";
import MailgunIcon from "./tech-icons/mailgun-icon.png";
import AmplitudeIcon from "./tech-icons/amplitude-icon.jpg";
import MetabaseIcon from "./tech-icons/metabase-icon.jpg";
import GitIcon from "./tech-icons/git-icon.png";
import GithubIcon from "./tech-icons/github-icon.jpg";
import GithubActionsIcon from "./tech-icons/gh-actions-icon.png";
import DockerIcon from "./tech-icons/docker-icon.png";
import SentryIcon from "./tech-icons/sentry-icon.png";
import CircleCIIcon from "./tech-icons/circleci-icon.jpg";
import DatadogIcon from "./tech-icons/datadog-icon.jpg";
import PapertrailIcon from "./tech-icons/papertrail-icon.png";
import VSCodeIcon from "./tech-icons/vscode-icon.png";
import SlackIcon from "./tech-icons/slack-icon.jpg";
import JiraIcon from "./tech-icons/jira-icon.jpg";
import ConfluenceIcon from "./tech-icons/confluence-icon.jpg";
import DovetailIcon from "./tech-icons/dovetail-icon.png";
import JSIcon from "./tech-icons/js-icon.jpeg";
import JQueryIcon from "./tech-icons/jquery-icon.jpg";
import JQueryUIIcon from "./tech-icons/jqueryui-icon.png";
import HTML5Icon from "./tech-icons/html5-icon.png";
import PHPIcon from "./tech-icons/php-icon.jpg";
import SASSIcon from "./tech-icons/sass-icon.png";
import AngularIcon from "./tech-icons/angular-icon.png";
import SQLServerIcon from "./tech-icons/sql-server-icon.jpg";
import ExtJSIcon from "./tech-icons/sencha-icon.jpg";
import PHPStormIcon from "./tech-icons/phpstorm-icon.png";
import MongoIcon from "./tech-icons/mongo-icon.png";
import VueIcon from "./tech-icons/vue-icon.png";
import GoIcon from "./tech-icons/go-icon.png";
import MUIIcon from "./tech-icons/mui-icon.png";
import IonicIcon from "./tech-icons/ionic-icon.jpg";
import CouchDBIcon from "./tech-icons/couchdb-icon.jpg";
import K8SIcon from "./tech-icons/k8s-icon.png";
import JenkinsIcon from "./tech-icons/jenkins-icon.png";
import WebpackIcon from "./tech-icons/webpack-icon.png";
import BitbucketIcon from "./tech-icons/bitbucket-icon.jpg";
import GulpIcon from "./tech-icons/gulp-icon.png";
import GruntIcon from "./tech-icons/grunt-icon.png";
import WebstormIcon from "./tech-icons/webstorm-icon.png";
import PythonIcon from "./tech-icons/python-icon.png";
import CSS3Icon from "./tech-icons/css3-icon.png";
import DjangoIcon from "./tech-icons/django-icon.png";
import GCPIcon from "./tech-icons/gcp-icon.jpg";
import StorybookIcon from "./tech-icons/storybook-icon.png";
import HelmIcon from "./tech-icons/helm-icon.jpg";
import CockroachDBIcon from "./tech-icons/cockroachdb-icon.png";
import GAIcon from "./tech-icons/ga-icon.jpg";
import PostmanIcon from "./tech-icons/postman-icon.png";
import ElasticIcon from "./tech-icons/elastic-icon.png";
import CopilotIcon from "./tech-icons/copilot-icon.png";
import NPMIcon from "./tech-icons/npm-icon.png";
import GitlabIcon from "./tech-icons/gitlab-icon.png";
import YarnIcon from "./tech-icons/yarn-icon.jpg";
import KibanaIcon from "./tech-icons/kibana-icon.png";
import GrafanaIcon from "./tech-icons/grafana-icon.jpg";
import JestIcon from "./tech-icons/jest-icon.png";
import CypressIcon from "./tech-icons/cypress-icon.png";
import ConsulIcon from "./tech-icons/consul-icon.png";
import RancherIcon from "./tech-icons/rancher-icon.png";
import SnykIcon from "./tech-icons/snyk-icon.jpg";
import ConfigCatIcon from "./tech-icons/configcat-icon.png";
import TeamsIcon from "./tech-icons/teams-icon.png";
import SketchIcon from "./tech-icons/sketch-icon.png";
import ClickUpIcon from "./tech-icons/clickup-icon.png";
import CloudflareIcon from "./tech-icons/cloudflare-icon.png";
import RedisIcon from "./tech-icons/redis-icon.png";
import EC2Icon from "./tech-icons/amazon-ec2-icon.png";
import FirebaseIcon from "./tech-icons/firebase-icon.jpg";
import LambdaIcon from "./tech-icons/aws-lambda-icon.png";
import CloudfrontIcon from "./tech-icons/amazon-cloudfront-icon.png";
import ServerlessIcon from "./tech-icons/serverless-icon.png";
import SemanticUIIcon from "./tech-icons/semantic-ui-icon.png";
import StripeIcon from "./tech-icons/stripe-icon.png";
import CloudwatchIcon from "./tech-icons/amazon-cloudwatch-icon.png";
import MochaIcon from "./tech-icons/mocha-icon.png";
import XRayIcon from "./tech-icons/aws-x-ray-icon.png";
import ExpressIcon from "./tech-icons/express-icon.png";
import RDSIcon from "./tech-icons/amazon-rds-icon.png";
import HandlebarsIcon from "./tech-icons/handlebars-icon.png";
import NestJSIcon from "./tech-icons/nestjs-icon.jpg";
import SQSIcon from "./tech-icons/amazon-sqs-icon.png";
import ChargebeeIcon from "./tech-icons/chargebee-icon.png";
import TerraformIcon from "./tech-icons/terraform-icon.png";
import HubspotIcon from "./tech-icons/hubspot-icon.jpg";
import IntercomIcon from "./tech-icons/intercom-icon.png";
import NotionIcon from "./tech-icons/notion-icon.jpg";
import ProductboardIcon from "./tech-icons/productboard-icon.png";
import PandadocIcon from "./tech-icons/pandadoc-icon.jpg";
import NginxIcon from "./tech-icons/nginx-icon.png";
import MariaDBIcon from "./tech-icons/mariadb-icon.png";
import SupabaseIcon from "./tech-icons/supabase-icon.jpg";
import RemixIcon from "./tech-icons/remix-icon.png";
import MendixIcon from "./tech-icons/mendix-icon.jpg";
import PrimeReactIcon from "./tech-icons/prime-react-icon.jpg";
import SendGridIcon from "./tech-icons/sendgrid-icon.jpg";
import GatsbyIcon from "./tech-icons/gatsby-icon.png";
import LeafletIcon from "./tech-icons/leaflet-icon.png";
import VercelIcon from "./tech-icons/vercel-icon.png";
import InsomniaIcon from "./tech-icons/insomnia-icon.jpg";
import PrometheusIcon from "./tech-icons/prometheus-icon.png";
import LaunchDarklyIcon from "./tech-icons/ld-icon.png";
import FigmaIcon from "./tech-icons/figma-icon.png";
import MiroIcon from "./tech-icons/miro-icon.png";
import DrawIcon from "./tech-icons/draw-icon.jpg";
import JavaIcon from "./tech-icons/java-icon.png";
import LinuxIcon from "./tech-icons/linux-icon.png";
import AssemblyIcon from "./tech-icons/assembly-icon.png";
import CIcon from "./tech-icons/c-icon.png";
import BashIcon from "./tech-icons/bash-icon.png";
import ValaIcon from "./tech-icons/vala-icon.jpg";
import VimIcon from "./tech-icons/vim-icon.png";
import EclipseIcon from "./tech-icons/eclipse-icon.png";

export const EclipseTech = {
  imgSrc: EclipseIcon,
  label: "Eclipse",
};
export const VimTech = {
  imgSrc: VimIcon,
  label: "Vim",
};
export const ValaTech = {
  imgSrc: ValaIcon,
  label: "Vala",
};
export const BashTech = {
  imgSrc: BashIcon,
  label: "Bash",
};
export const CTech = {
  imgSrc: CIcon,
  label: "C",
};
export const AssemblyTech = {
  imgSrc: AssemblyIcon,
  label: "Assembly",
};
export const LinuxTech = {
  imgSrc: LinuxIcon,
  label: "Linux",
};
export const JavaTech = {
  imgSrc: JavaIcon,
  label: "Java",
};
export const DrawTech = {
  imgSrc: DrawIcon,
  label: "Draw",
};
export const MiroTech = {
  imgSrc: MiroIcon,
  label: "Miro",
};
export const FigmaTech = {
  imgSrc: FigmaIcon,
  label: "Figma",
};
export const LaunchDarklyTech = {
  imgSrc: LaunchDarklyIcon,
  label: "LaunchDarkly",
};
export const PrometheusTech = {
  imgSrc: PrometheusIcon,
  label: "Prometheus",
};
export const InsomniaTech = {
  imgSrc: InsomniaIcon,
  label: "Insomnia",
};
export const VercelTech = {
  imgSrc: VercelIcon,
  label: "Vercel",
};
export const LeafletTech = {
  imgSrc: LeafletIcon,
  label: "Leaflet",
};
export const GatsbyTech = {
  imgSrc: GatsbyIcon,
  label: "Gatsby",
};
export const SendGridTech = {
  imgSrc: SendGridIcon,
  label: "SendGrid",
};
export const PrimeReactTech = {
  imgSrc: PrimeReactIcon,
  label: "Prime React",
};
export const MendixTech = {
  imgSrc: MendixIcon,
  label: "Mendix",
};
export const RemixTech = {
  imgSrc: RemixIcon,
  label: "Remix",
};
export const SupabaseTech = {
  imgSrc: SupabaseIcon,
  label: "Supabase",
};
export const MariaDBTech = {
  imgSrc: MariaDBIcon,
  label: "MariaDB",
};
export const NginxTech = {
  imgSrc: NginxIcon,
  label: "Nginx",
};
export const PandadocTech = {
  imgSrc: PandadocIcon,
  label: "Pandadoc",
};
export const ProductboardTech = {
  imgSrc: ProductboardIcon,
  label: "Productboard",
};
export const NotionTech = {
  imgSrc: NotionIcon,
  label: "Notion",
};
export const IntercomTech = {
  imgSrc: IntercomIcon,
  label: "Intercom",
};
export const HubspotTech = {
  imgSrc: HubspotIcon,
  label: "Hubspot",
};
export const TerraformTech = {
  imgSrc: TerraformIcon,
  label: "Terraform",
};
export const ChargebeeTech = {
  imgSrc: ChargebeeIcon,
  label: "Chargebee",
};
export const SQSTech = {
  imgSrc: SQSIcon,
  label: "SQS",
};
export const NestJSTech = {
  imgSrc: NestJSIcon,
  label: "NestJS",
};
export const HandlebarsTech = {
  imgSrc: HandlebarsIcon,
  label: "Handlebars",
};
export const RDSTech = {
  imgSrc: RDSIcon,
  label: "RDS",
};
export const ExpressTech = {
  imgSrc: ExpressIcon,
  label: "Express",
};
export const XRayTech = {
  imgSrc: XRayIcon,
  label: "XRay",
};
export const MochaTech = {
  imgSrc: MochaIcon,
  label: "Mocha",
};
export const CloudwatchTech = {
  imgSrc: CloudwatchIcon,
  label: "Cloudwatch",
};
export const StripeTech = {
  imgSrc: StripeIcon,
  label: "Stripe",
};
export const SemanticUITech = {
  imgSrc: SemanticUIIcon,
  label: "SemanticUI",
};
export const ServerlessTech = {
  imgSrc: ServerlessIcon,
  label: "Serverless",
};
export const CloudfrontTech = {
  imgSrc: CloudfrontIcon,
  label: "Cloudfront",
};
export const LambdaTech = {
  imgSrc: LambdaIcon,
  label: "Lambda",
};
export const FirebaseTech = {
  imgSrc: FirebaseIcon,
  label: "Firebase",
};
export const EC2Tech = {
  imgSrc: EC2Icon,
  label: "EC2",
};
export const RedisTech = {
  imgSrc: RedisIcon,
  label: "Redis",
};
export const CloudflareTech = {
  imgSrc: CloudflareIcon,
  label: "Cloudflare",
};
export const ClickUpTech = {
  imgSrc: ClickUpIcon,
  label: "ClickUp",
};
export const SketchTech = {
  imgSrc: SketchIcon,
  label: "Sketch",
};
export const TeamsTech = {
  imgSrc: TeamsIcon,
  label: "Teams",
};
export const ConfigCatTech = {
  imgSrc: ConfigCatIcon,
  label: "ConfigCat",
};
export const SnykTech = {
  imgSrc: SnykIcon,
  label: "Snyk",
};
export const RancherTech = {
  imgSrc: RancherIcon,
  label: "Rancher",
};
export const ConsulTech = {
  imgSrc: ConsulIcon,
  label: "Consul",
};
export const CypressTech = {
  imgSrc: CypressIcon,
  label: "Cypress",
};
export const JestTech = {
  imgSrc: JestIcon,
  label: "Jest",
};
export const GrafanaTech = {
  imgSrc: GrafanaIcon,
  label: "Grafana",
};
export const KibanaTech = {
  imgSrc: KibanaIcon,
  label: "Kibana",
};
export const YarnTech = {
  imgSrc: YarnIcon,
  label: "Yarn",
};
export const GitlabTech = {
  imgSrc: GitlabIcon,
  label: "Gitlab",
};
export const NPMTech = {
  imgSrc: NPMIcon,
  label: "NPM",
};
export const CopilotTech = {
  imgSrc: CopilotIcon,
  label: "Copilot",
};
export const ElasticTech = {
  imgSrc: ElasticIcon,
  label: "Elastic",
};
export const PostmanTech = {
  imgSrc: PostmanIcon,
  label: "Postman",
};
export const GATech = {
  imgSrc: GAIcon,
  label: "Google Analytics",
};
export const CockroachDBTech = {
  imgSrc: CockroachDBIcon,
  label: "Cockroach DB",
};
export const HelmTech = {
  imgSrc: HelmIcon,
  label: "Helm",
};
export const StorybookTech = {
  imgSrc: StorybookIcon,
  label: "Storybook",
};
export const GCPTech = {
  imgSrc: GCPIcon,
  label: "Google Cloud Platform",
};
export const NodeJsTech = {
  imgSrc: NodeJsIcon,
  label: "NodeJS",
};
export const DjangoTech = {
  imgSrc: DjangoIcon,
  label: "Django",
};
export const TsTech = {
  imgSrc: TsIcon,
  label: "Typescript",
};
export const ReactTech = {
  imgSrc: ReactIcon,
  label: "React",
};
export const PostgresTech = {
  imgSrc: PostgresIcon,
  label: "PostgresSQL",
};
export const S3Tech = {
  imgSrc: S3Icon,
  label: "S3",
};
export const GQLTech = {
  imgSrc: GQLIcon,
  label: "GraphQL",
};
export const ReduxTech = {
  imgSrc: ReduxIcon,
  label: "Redux",
};
export const HerokuTech = {
  imgSrc: HerokuIcon,
  label: "Heroku",
};
export const KafkaTech = {
  imgSrc: KafkaIcon,
  label: "Kafka",
};
export const NextJSTech = {
  imgSrc: NextJSIcon,
  label: "NextJS",
};
export const ApolloTech = {
  imgSrc: ApolloIcon,
  label: "Apollo",
};
export const StyledComponentsTech = {
  imgSrc: StyledComponentIcon,
  label: "Styled Components",
};
export const MailgunTech = {
  imgSrc: MailgunIcon,
  label: "Mailgun",
};
export const AmplitudeTech = {
  imgSrc: AmplitudeIcon,
  label: "Amplitude",
};
export const MetabaseTech = {
  imgSrc: MetabaseIcon,
  label: "Metabase",
};
export const GitTech = {
  imgSrc: GitIcon,
  label: "Git",
};
export const GithubTech = {
  imgSrc: GithubIcon,
  label: "Github",
};
export const GithubActionsTech = {
  imgSrc: GithubActionsIcon,
  label: "Github Actions",
};
export const DockerTech = {
  imgSrc: DockerIcon,
  label: "Docker",
};
export const SentryTech = {
  imgSrc: SentryIcon,
  label: "Sentry",
};
export const CircleCITech = {
  imgSrc: CircleCIIcon,
  label: "CircleCI",
};
export const DatadogTech = {
  imgSrc: DatadogIcon,
  label: "Datadog",
};
export const PapertrailTech = {
  imgSrc: PapertrailIcon,
  label: "Papertrail",
};
export const VSCodeTech = {
  imgSrc: VSCodeIcon,
  label: "VSCode",
};
export const SlackTech = {
  imgSrc: SlackIcon,
  label: "Slack",
};
export const JiraTech = {
  imgSrc: JiraIcon,
  label: "Jira",
};
export const ConfluenceTech = {
  imgSrc: ConfluenceIcon,
  label: "Confluence",
};
export const DovetailTech = {
  imgSrc: DovetailIcon,
  label: "Dovetail",
};
export const JSTech = {
  imgSrc: JSIcon,
  label: "Javascript",
};
export const JQueryTech = {
  imgSrc: JQueryIcon,
  label: "JQuery",
};
export const JQueryUITech = {
  imgSrc: JQueryUIIcon,
  label: "JQuery UI",
};
export const HTML5Tech = {
  imgSrc: HTML5Icon,
  label: "HTML5",
};
export const PHPTech = {
  imgSrc: PHPIcon,
  label: "PHP",
};
export const SASSTech = {
  imgSrc: SASSIcon,
  label: "Sass",
};
export const AngularTech = {
  imgSrc: AngularIcon,
  label: "Angular",
};
export const SQLServerTech = {
  imgSrc: SQLServerIcon,
  label: "SQL Server",
};
export const ExtJSTech = {
  imgSrc: ExtJSIcon,
  label: "ExtJS",
};
export const SenchaTouchTech = {
  imgSrc: ExtJSIcon,
  label: "Sencha Touch",
};
export const PHPStormTech = {
  imgSrc: PHPStormIcon,
  label: "PHPStorm",
};
export const MongoTech = {
  imgSrc: MongoIcon,
  label: "MongoDB",
};
export const VueTech = {
  imgSrc: VueIcon,
  label: "VueJS",
};
export const GoTech = {
  imgSrc: GoIcon,
  label: "Go Lang",
};
export const MUITech = {
  imgSrc: MUIIcon,
  label: "Material Design",
};
export const IonicTech = {
  imgSrc: IonicIcon,
  label: "Ionic",
};
export const CouchDBTech = {
  imgSrc: CouchDBIcon,
  label: "Couch DB",
};
export const K8STech = {
  imgSrc: K8SIcon,
  label: "Kubernetes",
};
export const JenkinsTech = {
  imgSrc: JenkinsIcon,
  label: "Jenkins",
};
export const WebpackTech = {
  imgSrc: WebpackIcon,
  label: "Webpack",
};
export const BitbucketTech = {
  imgSrc: BitbucketIcon,
  label: "Bitbucket",
};
export const GulpTech = {
  imgSrc: GulpIcon,
  label: "Gulp",
};
export const GruntTech = {
  imgSrc: GruntIcon,
  label: "Grunt",
};
export const WebstormTech = {
  imgSrc: WebstormIcon,
  label: "Webstorm",
};
export const PythonTech = {
  imgSrc: PythonIcon,
  label: "Python",
};
export const CSS3Tech = {
  imgSrc: CSS3Icon,
  label: "CSS3",
};
